import { Component, Host, Prop, h } from "@stencil/core";

/**
 * @slot (text) - for the text element of the teaser-magazine
 * @slot (link) - for the link element of the teaser-magazine
 */

@Component({
    tag: "ux-iws-teaser-magazine",
    styleUrl: "teaser-magazine.scss",
})
export class MagazineTeaser {
    private baseClass = "ux-iws-teaser-magazine";

    /** the name of the icon of the teaser */
    @Prop() icon: string = null;
    /** the name of the headline of the teaser */
    @Prop() headline: string = null;
    /** the variant of the magazine teaser */
    @Prop() variant?: "grey" | "blue" = "grey";

    render() {
        return (
            <Host class={`${this.baseClass}`}>
                <div
                    class={{
                        [`${this.baseClass}__box`]: true,
                        [`${this.baseClass}__box--variant-blue`]:
                            this.variant === "blue",
                    }}
                >
                    <ux-icon
                        name={this.icon}
                        weight="light"
                        size-s="60"
                        size-m="80"
                        size-l="100"
                        fill={this.variant === "blue" ? "white" : "black"}
                    ></ux-icon>
                    <div class={`${this.baseClass}__box-content`}>
                        <div class="ux-text-headline ux-text-headline--big">
                            {this.headline}
                        </div>
                        <slot name="text"></slot>
                        <slot name="link"></slot>
                    </div>
                </div>
                <div class={`${this.baseClass}__box-bg`}></div>
            </Host>
        );
    }
}
